<span class="default-tab-indicator qa-default-tab-indicator" *ngIf="defaultTab == currentTab">
    <icon class="default-tab-icon icon aa-icon-star-icon-on"></icon>
    <span translate="markAsDefaultView"></span>
</span>
<button class="transparent default-tab-indicator qa-default-tab-indicator" *ngIf="!(defaultTab == currentTab)" (click)="onClickMarkAsDefault()">
    <icon class="default-tab-icon icon aa-icon-star-icon-off"></icon>
    <span translate="markAsDefaultView"></span>
</button>
